interface Props {
  size?: number;
  color?: string;
}

const IdCardIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 24 24`}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2.074 6.486v11.028c0 1.218.988 2.206 2.206 2.206h15.44a2.206 2.206 0 0 0 2.206-2.206V6.486A2.206 2.206 0 0 0 19.72 4.28H4.28a2.206 2.206 0 0 0-2.206 2.206"
        clipRule="evenodd"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        d="M15.31 9.794h3.308M15.31 13.103h3.308"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10.898 9.795a2.206 2.206 0 1 1-4.411 0 2.206 2.206 0 0 1 4.411 0"
        clipRule="evenodd"
      ></path>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        d="M4.28 16.412c3.07-3.46 6.675-2.372 8.823 0"
      ></path>
    </svg>
  );
};

export default IdCardIcon;
